// @flow
import 'prelude';

// import Symbol from 'core-js/es6/symbol';
import Map from 'core-js/es6/map';

import _ from 'lodash';
import ko from 'rgs-knockout';


const _hash: Symbol = Symbol('_hash');
const _map: Symbol = Symbol('_map');
const _state: Symbol = Symbol('_state');


interface Indexable<K, V> {
  [key: K | V]: V | K
}

export interface IObservableMap<K, V> extends Indexable<K, V> {
	notify(): void;
	has(k: ?K): boolean;
	get(k: ?K): V;
	set(k: ?K, v: ?V, dontNotify: ?boolean): void;
	setAbsent(k: ?K, v: ?V, dontNotify: ?boolean): void;
	biset(k: ?K, v: ?V, dontNotify: ?boolean): void;
	bisetAbsent(k: ?K, v: ?V, dontNotify: ?boolean): void;
	delete(k: ?K, dontNotify: ?boolean): void;
	each(callback: Function): void;
	keys(): Array<any>;
	values(): Array<any>;
	clear(dontNotify: ?boolean): void;
}

// TODO: `batch` method instead of `dontNotify` arguments
export default class ObservableMap<K, V>
	implements IObservableMap<K, V> {
	constructor (options: ?{hash: Function}) {
		options = _.extend({}, {
			hash: _.identity,
		}, options);

		this[_hash] = options.hash;

		this[_map] = new Map;

		// Observable counter which computed can depend on
		this[_state] = ko.observable(0);
	}

	notify = (): void => {
		this[_state](this[_state]() + 1);
	}

	has = (k: ?K | ?V): boolean => {
		this[_state]();
		return this[_map].has(this[_hash](k));
	}

	get = (k: ?K | ?V): any => {
		this[_state]();
		return this[_map].get(this[_hash](k));
	}

	set = (k: ?K | V, v: ?V | ?K, dontNotify: ?boolean): void => {
		const hash = this[_hash](k);
		this[_map].set(hash, v);
		if (!dontNotify) {
			this.notify();
		}
	}

	setAbsent = (k: ?K | ?V, v: ?V | ?K, dontNotify: ?boolean): void => {
		if (!this.has(k)) {
			this.set(k, v, dontNotify);
		}
	}

	biset = (k: ?K, v: ?V, dontNotify: ?boolean): void => {
		this.set(k, v, true);
		this.set(v, k, dontNotify);
	}

	bisetAbsent = (k: ?K, v: ?V, dontNotify: ?boolean): void => {
		this.setAbsent(k, v, true);
		this.setAbsent(v, k, dontNotify);
	}

	delete = (k: ?K, dontNotify: ?boolean): void => {
		if (this.has(k)) {
			this[_map].delete(k);
			if (!dontNotify) {
				this.notify();
			}
		}
	}

	each = (callback: Function): void => {
		this[_state]();
		this[_map].forEach(callback);
	}

	keys = (): Array<any> => {
		this[_state]();
		return Array.from(this[_map].keys());
	}

	values = (): Array<any> => {
		this[_state]();
		return Array.from(this[_map].values());
	}

	clear = (dontNotify: ?boolean): void => {
		this[_map] = new Map;
		if (!dontNotify) {
			this.notify();
		}
	}
}